export default [
  {
    text: 'ビリニュスで開催された国際科学会議 <a href="https://openreadings.eu/">OpenReadings</a> に参加。',
    year: '2026',
  },
  {
    text: '2024年夏期の <a href="https://home.cern/about/who-we-are/our-governance">CERN</a> メンバーシップ。',
    year: '2024',
  },
  { text: 'Acert B2 英語証明書', year: '2024' },
  {
    text: '<a href="https://www.stypendia-pomostowe.pl">ブリッジ奨学金</a> プログラムによる奨学金。',
    year: '2023',
  },
  {
    text: '<a href="https://www.podparpackie.edu.pl">才能ある学生のための奨学金支援</a> プログラムによる奨学金を再受賞。',
    year: '2022',
  },
  {
    text: '<a href="https://soulgraphy.me">Soulgraphy</a> プロジェクトがインターネット上で10万回の閲覧数を達成。',
    year: '2021',
  },
  {
    text: '<a href="https://www.podparpackie.edu.pl">才能ある学生のための奨学金支援</a> プログラムによる奨学金。',
    year: '2020',
  },
  {
    text: '全国物理コンテスト「Albus」入賞（8位）。',
    year: '2019',
  },
  { text: '地方物理コンテスト入賞。', year: '2019' },
  {
    text: '全国コンテスト「Olimpus」数学（5位）と物理（9位）のダブル入賞。',
    year: '2019',
  },
]
